<div class="offboarding-card">
    <div class="offboarding-header">
        <div class="header-container">
            <app-title-field
              [title]="'Upcoming Off-boarding'"
              [icon]="'person_off'"
              [iconVariant]="'outlined'"
              [showLink]="true"
              (click)="navigateToOffboarding()"
            ></app-title-field>
        </div>
        <div>
          <div>
      <app-dropdown
        [options]="monthOptions"
        [label]="'Select Month'"
        [displayKey]="'label'"
        [valueKey]="'value'"
        [(ngModel)]="selectedMonthValue"
        (dropdownChange)="onMonthSelect($event)"
      ></app-dropdown>
      </div>
    </div>
    </div>

     <div *ngIf="isLoading" class="card-loading-overlay">
        <div class="card-spinner">
            <div class="spinner"></div>
            <span class="loading-text">Loading...</span>
        </div>
    </div> 

     <div *ngIf="!isLoading && offboardingData.length > 0; else noDataTemplate" class="datatable-container">
        <app-table [columnDefs]="UPCOMING_OFFBOARDING_COLUMNS"
          [rowData]="offboardingData"
          [gridOptions]="gridOptions"
          [enableActions]="tableConfig.enableActions || false"
          [enablePagination]="tableConfig.enablePagination ?? true"
          [paginationPageSize]="tableConfig.paginationPageSize || 10"
          [enableRowSelection]="tableConfig.enableRowSelection || false"
          [rowSelectionMode]="tableConfig.rowSelectionMode || 'multiple'"
          [enableSorting]="tableConfig.enableSorting ?? true"
          [enableFiltering]="tableConfig.enableFiltering ?? true"
          [enableColumnResize]="tableConfig.enableColumnResize ?? true"
          [height]="maxTableHeight"
        >
      </app-table>
    </div>

    <ng-template #noDataTemplate>
        <section class="records-container" aria-label="Records section">
            <div class="empty-state">
                <ng-container>
                    <h3 class="empty-state-title">No data available</h3>
                </ng-container>
                <img
                    src="assets/img/no-data-found.png"
                    alt="No records illustration"
                    class="empty-state-image"
                />
            </div>
        </section>
    </ng-template>
</div>
